import React, {useEffect, useRef, useState} from "react";
import {arraySorter, DatePicker, Form, InputBox, notification, Table} from "../../components/Elements/appUtils";
import PageHeader from "../../components/Elements/pageHeader";
import _ from "lodash";
import {captainReportingFxn, fetchProduct} from "../products/actions";
import {GetEachFormFields} from "../../components/_utils/formUtils";
import moment from "moment";

function CaptainReporting(props) {
    let tableRef = useRef();
    const {getFieldValue} = props.form;
    let [products, setProducts] = useState([]);
    const [activeTab, setActiveTab] = useState("today");
    const [dates, setDates] = useState({
        fromDate: '',
        toDate: '',
    });

    const apiRequest = (params) => {
        return new Promise(async (resolve) => {
            try {
                if (dates.fromDate && dates.toDate) {
                    params.fromD = moment(dates.fromDate).startOf('day')._d
                    params.toD = moment(dates.toDate).endOf('day')._d
                }
                const data = await captainReportingFxn({...params});
                resolve(data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        });
    };

    const getProducts = async (params = {}) => {
        params.results = 10000
        const data = await fetchProduct({...params});
        setProducts(arraySorter(data.data.data))
    }

    useEffect(() => {
        getProducts()
        let currentDate = moment();
        let firstDayOfMonth = moment(currentDate).startOf('month');
        let lastDayOfMonth = moment(currentDate).endOf('month');
        props.form.setFieldsValue({
            fromD: firstDayOfMonth,
            toD: lastDayOfMonth,
        });
        // loadTables() //4-6-24
        // loadUsers() //4-6-24
    }, [])

    useEffect(() => {
        let fromDate = getFieldValue('fromD');
        let toDate = getFieldValue('toD');
        const fromDateObj = new Date(fromDate);
        const toDateObj = new Date(toDate);
        const timeDifference = Math.abs(toDateObj.getTime() - fromDateObj.getTime());
        const differenceInDays = Math.ceil(timeDifference / (1000 * 3600 * 24));

        if (differenceInDays > 31) {
            notification.warning({
                message: 'Difference Between From Date And To Date Cannot Exceeds 1 Month'
            });
            props.form.setFieldsValue({
                toD: ''
            })
        }
    }, [getFieldValue('fromD'), getFieldValue('toD')])


    const refreshTable = () => {
        tableRef.current.reload();
    };
    const columns = [
        {
            title: "Sr. No",
            dataIndex: "serialNo",
            key: "serialNo",
            render: (text, record, index) => index + 1,
        },
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Kot's",
            dataIndex: "count",
            key: "count",
        },
        {
            title: "Total Amount",
            dataIndex: "totalAmount",
            key: "totalAmount",
            render: (text) => {
                return <>Rs. {text ? text : 0}</>;
            },
        },
    ];

    const getColumns = () => {
        let columnArr = [];
        _.each(columns, (item) => {
            if (!item.hide) {
                columnArr.push(item);
            }
        });
        return columnArr;
    };


    const handleDateTab = (key) => {
        setActiveTab(key);

        const today = new Date();
        let from, to;

        switch (key) {
            case "today":
                from = to = today;
                break;

            case "7days":
                from = new Date();
                from.setDate(today.getDate() - 7);
                to = today;
                break;

            case "1month":
                from = new Date();
                from.setMonth(today.getMonth() - 1);
                to = today;
                break;

            case "3months":
                from = new Date();
                from.setMonth(today.getMonth() - 3);
                to = today;
                break;

            case "custom":
                from = '';
                to = '';
                break;

            default:
                from = to = today;
        }

        setDates({fromDate: from, toDate: to});
    };

    return (
        <PageHeader title={"Captain Reporting"}>
            <div className="row mb-3">
                <Form onSubmit={refreshTable}>
                    <div className="card">
                        <div className="card-body">
                            <div className="form-elements-wrapper">
                                <div className={"row"}>
                                    <div className="col-md-12 mb-3">
                                        <div className="btn-group">
                                            {[
                                                {key: "today", label: "Today"},
                                                {key: "7days", label: "Last 7 Days"},
                                                {key: "1month", label: "Last Month"},
                                                {key: "3months", label: "Last 3 Months"},
                                                {key: "custom", label: "Custom"},
                                            ].map(tab => (
                                                <button
                                                    key={tab.key}
                                                    className={`btn btn-outline-primary ${activeTab === tab.key ? 'activeDuration' : ''}`}
                                                    onClick={() => handleDateTab(tab.key)}
                                                >
                                                    {tab.label}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Show DatePicker only when Custom is selected */}
                                    {activeTab == "custom" && (
                                        <>
                                            <div className="col-md-2">
                                                <InputBox title={'From Date'}>
                                                    <DatePicker
                                                        value={dates.fromDate}
                                                        showClear={true}
                                                        placeholder={'Choose from Date'}
                                                        onChange={(value) => setDates({...dates, fromDate: value})}
                                                    />
                                                </InputBox>
                                            </div>
                                            <div className="col-md-2">
                                                <InputBox title={'To Date'}>
                                                    <DatePicker
                                                        value={dates.toDate}
                                                        showClear={true}
                                                        placeholder={'Choose to Date'}
                                                        onChange={(value) => setDates({...dates, toDate: value})}
                                                    />
                                                </InputBox>
                                            </div>
                                        </>
                                    )}
                                    <button className="btn btn-info col-md-1 ms-3 h-25 mt-4"
                                            onClick={refreshTable}>
                                        Search
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
            <div className="card">
                <div className="table-responsive">
                    <Table
                        apiRequest={apiRequest}
                        columns={getColumns()}
                        ref={tableRef}
                    />
                </div>
            </div>
        </PageHeader>
    );
}

export default Form.create()(CaptainReporting);
